import { tss } from "tss-react/mui";

export const useShopCatalogSectionStyles = tss.withName("ShopCatalogSection").create(({ theme }) => ({
    layout: {
        display: "grid",
        gridTemplateColumns: "240px 1fr",
        gap: theme.spacing(5),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
    },
    sidebar: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(4),
    },
    filterGroup: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(1),
    },
    filterGroupTitle: {
        fontWeight: 700,
        fontSize: "0.85rem",
        marginBottom: theme.spacing(0.5),
    },
    chipRow: {
        display: "flex",
        flexWrap: "wrap" as const,
        gap: theme.spacing(1),
    },
    resetButton: {
        alignSelf: "flex-start" as const,
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(3),
        flexWrap: "wrap" as const,
        gap: theme.spacing(1.5),
    },
    resultsCount: {
        color: theme.palette.text.secondary,
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: theme.spacing(5),
        "& > *:nth-of-type(5n+1)": {
            gridColumn: "span 2",
        },
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            "& > *:nth-of-type(5n+1)": {
                gridColumn: "span 1",
            },
        },
        [theme.breakpoints.down("sm")]: {
            gap: theme.spacing(4),
        },
    },
    noResults: {
        color: theme.palette.text.secondary,
        textAlign: "center" as const,
        padding: theme.spacing(6, 0),
    },
}));
